import { AutoComplete, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import "./StandType.css";
import { surveyService } from '../../services';

const renderTitle = (title) => (
    <span>
      {title}
    </span>
);
  
const renderItem = (option) => ({
    value: option.value,
    label: (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
        {option.title}
        </div>
    ),
});

const StandType = ({onSelect, loading, ...props}) => {
    const [municipalities, setMunicipalities] = useState([])
    const [options, setOptions] = useState([])
    const [searchTerm, setSearchTerm] = useState(null)
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await surveyService.getRouterJLS()
                const initialData = response?.map(d => ({label: d.name, value: d.name}))
                setMunicipalities(initialData)
                setOptions(municipalities)
            }
            catch(error) {


            }
        }
        fetchData()
    }, [])

    const handleSearch = (searchText) => {
        !searchText ? setOptions(municipalities) :
        setOptions(municipalities.filter(m => m.label.toUpperCase().includes(searchText?.toUpperCase())))

        setSearchTerm(searchTerm)
    }

    const handleFocus = (searchText) => {
        !searchTerm ? setOptions(municipalities) :
        setOptions(municipalities.filter(m => m.label.toUpperCase().includes(searchTerm?.toUpperCase())))
    }

    return null

    return (
    
    <div className='municipality-search' {...props}>
        <AutoComplete
            allowClear
            backfill
            popup_class_name="municipality-search__dropdown"
            options={options}
            onSearch={handleSearch}
            onFocus={handleFocus}
            onSelect={onSelect}
            disabled={loading}
            //options={options.map(o => ({label: renderTitle(o.label), options: o.choices?.map(c => renderItem(c))}))}
        >
            <Input size="large" placeholder="Vrsta stalka" />
        </AutoComplete>
        </div>
    )
}

export default StandType;